module.exports = __webpack_public_path__ + "media/images/flags/et-761243b8b79ab99b36d19404e2d8d2e5.svg";